export var Period;
(function (Period) {
    Period["DAY"] = "DAY";
    Period["WEEK"] = "WEEK";
    Period["MONTH"] = "MONTH";
    Period["YEAR"] = "YEAR";
    Period["NONE"] = "NONE";
})(Period || (Period = {}));
export const PeriodTranslation = {
    [Period.DAY]: 'Dziennie',
    [Period.WEEK]: 'Tygodniowo',
    [Period.MONTH]: 'Miesięcznie',
    [Period.YEAR]: 'Rocznie',
    [Period.NONE]: 'Brak okresu'
};
//# sourceMappingURL=period.enum.js.map